import React from 'react';
import BaseFaq from 'components/Faq';

export default function Faq() {
  return (
    <BaseFaq
      items={[
        {
          question: 'What is the Friends Referral program?',
          answer:
            'The Friends Referral program is a way for our passionate scientists to earn exclusive rewards and share their love for scientific communication with future science graph lovers by inviting them to join Mind the Graph team with a free trial experience, and most importantly by having fun unraveling the scientific illustration world and its benefits.',
        },
        {
          question: 'Do my friends need to be Mind the Graph subscribers to get an invite?',
          answer:
            "No, your friends don't need an account to be invited. They will receive an invitation for a 7-day trial Researcher Subscription by email and then they can create their brand new account.",
        },
        {
          question: 'How do I participate as a subscriber?',
          answer:
            "If you're already a Mind the Graph subscriber, all you have to do is login, invite as many friends as you want and they will receive a 7-day trial invitation by email. For each friend that officially starts the trial in Mind the Graph, you will get a 10% discount on your plan for a month. You can reach up to 10 friends confirmed at the trial from your invitations resulting in a 100% discount.",
        },
        {
          question: 'What if I am a Starter user?',
          answer:
            'Starters can also participate, earning a 7-day trial on a Researcher Plan for themselves and friends. Just login, refer at least 3 friends, follow the steps and enjoy Unlimited Scientific Illustrations, creations and more for free for 7 days.',
        },
        {
          question: 'What are the rewards?',
          answer:
            'For Student and Researcher subscribers, the reward is a discount percentage on their subscriptions fees for the following month, getting up to a 100% discount each month. As for the new friends, the reward is a free 7-day trial on a Researcher plan at Mind the Graph. For Starter subscribers, the reward is a free 7-day trial on a Researcher subscription with 5 custom illustration requests included for them and their referred friends.',
        },
        {
          question: 'How do I receive my rewards?',
          answer:
            'You will receive your rewards and details by the email address registered to your Mind The Graph account. Your friends will receive their award by email also, the one you shared with us.',
        },
        {
          question: 'Can I participate more than once?',
          answer:
            "If you are a Student or Researcher subscriber at Mind the Graph, you can invite as many friends as you want, at any time and they will receive a trial invitation by email. For each friend that confirms and starts the trial, you will get a 10% discount, until you reach 100%, which corresponds to 10 friends that started the trial. If you are a Starter subscriber or don't have a Mind the Graph account yet, you can participate once, sending at least 3 invitations to your friends, up to as many more as you want.",
        },
      ]}
    />
  );
}
